import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  Backdrop,
  Button,
  Chip,
  FormFieldSet,
  LogoLoader,
  PageHeader,
  PageTitle,
  SmartTooltip,
  TableAdv,
} from "../../../../../components";
const WorkforceNotifications = () => {
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      category: "Employee",
      trigger: "Employee Start",
      recipients: [
        "Vikranth12@gmail.com",
        "Raghutek@gmail.com",
        "ThirdPerson@gmail.com",
        "Fourth@test.com",
      ],
      date: "10/10/2024",
      status: 2,
    },
    {
      id: 2,
      category: "Employee",
      trigger: "Immigration Document Expiry",
      recipients: ["Vikranth12@gmail.com", "Raghutek@gmail.com"],
      date: "10/10/2024",
      status: 1,
    },
    {
      id: 3,
      category: "Employee",
      trigger: "Payroll Processing Started",
      recipients: ["Vikranth12@gmail.com", "Raghutek@gmail.com"],
      date: "10/10/2024",
      status: 1,
    },
    {
      id: 4,
      category: "Employee",
      trigger: "Salary Revision",
      recipients: ["Vikranth12@gmail.com", "Raghutek@gmail.com"],
      date: "10/10/2024",
      status: 1,
    },
    {
      id: 5,
      category: "Employee",
      trigger: "Timesheet Submission Reminder",
      recipients: ["Vikranth12@gmail.com", "Raghutek@gmail.com"],
      date: "10/10/2024",
      status: 1,
    },
  ]);

  useEffect(() => {
    console.log("apii call to fetch notifications");
  }, []);

  const toggleStatus = (id) => {
    setNotifications((prev) =>
      prev.map((notif) =>
        notif.id === id
          ? { ...notif, status: notif.status === 1 ? 2 : 1 }
          : notif,
      ),
    );
  };
  const removeRecipient = (id, recipientToRemove) => {
    setNotifications((prev) =>
      prev.map((notif) =>
        notif.id === id
          ? {
              ...notif,
              recipients: notif.recipients.filter(
                (r) => r !== recipientToRemove,
              ),
            }
          : notif,
      ),
    );
  };
  const confirmDelete = () => {
    if (selectedDeleteId) {
      setNotifications((prev) => prev.filter((n) => n.id !== selectedDeleteId));
      setShowDeleteModal(false);
      setSelectedDeleteId(null);
    }
  };
  const handleDeleteClick = (id) => {
    setSelectedDeleteId(id);
    setShowDeleteModal(true);
  };
  const columns = [
    {
      key: "category",
      label: "Notification Category",
      columnMenu: false,
    },
    {
      key: "trigger",
      label: "Trigger Event",
      columnMenu: false,
    },
    {
      key: "recipients",
      label: "Recipients",
      columnMenu: false,
      minWidth: 300,
      render: (row) => {
        const recipients = row.recipients || [];
        const isExpanded = expandedRows[row.id];
        const displayRecipients = isExpanded
          ? recipients
          : recipients.slice(0, 2);
        const remainingCount = recipients.length - 2;
        return (
          <div className="flex flex-wrap gap-2 items-center">
            {displayRecipients.map((recipient) => (
              <Chip
                key={recipient}
                label={recipient}
                onDelete={() => removeRecipient(row.id, recipient)}
                color="info"
                variant="contained"
                size="md"
                className="text-info-500 border-info-300"
              />
            ))}
            {recipients.length > 2 && (
              <Chip
                label={isExpanded ? "Show Less" : `+${remainingCount} more`}
                onClick={() =>
                  setExpandedRows((prev) => ({
                    ...prev,
                    [row.id]: !isExpanded,
                  }))
                }
                color="info"
                variant="contained"
                size="md"
                className="text-info-500 border-info-300 cursor-pointer"
              />
            )}
          </div>
        );
      },
    },
    {
      key: "date",
      label: "Date",
      columnMenu: false,
    },
    {
      key: "status",
      label: "Status",
      columnMenu: false,
      render: (row) => (
        <div className="flex justify-center">
          <FormFieldSet
            noTitle
            type="toggle"
            isChecked={row.status === 1}
            onChange={() => toggleStatus(row.id)}
          />
        </div>
      ),
    },
    {
      key: "actions",
      label: "Actions",
      columnMenu: false,
      render: (row) => (
        <div className="flex justify-center gap-2">
          <SmartTooltip description={"Delete"} noicon tooltipPosition="top">
            <Button
              type="icon"
              variant="text"
              icon="delete"
              color="black"
              size="sm"
              onClick={() => handleDeleteClick(row.id)}
            />
          </SmartTooltip>
          <SmartTooltip description={"Edit"} noicon tooltipPosition="top">
            <Button
              type="icon"
              variant="text"
              icon="edit"
              color="black"
              size="sm"
              onClick={() =>
                navigate(
                  `/settings/notification-center/create?mode=edit&id=${row.id}`,
                  {
                    state: { isEdit: true, data: row },
                  },
                )
              }
            />
          </SmartTooltip>
        </div>
      ),
    },
  ];
  return (
    <div className="w-full h-full rounded-lg shadow-sm flex flex-col">
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"Notification Center"} tag="h5" />
          </div>
        }
        RightSection={
          <Button
            title="New Email"
            onClick={() =>
              navigate("/settings/notification-center/create?mode=create")
            }
          />
        }
      />
      <div className="flex-1 overflow-hidden px-4 pb-4">
        <TableAdv
          columns={columns}
          rows={notifications}
          toolbarRight={{ filter: false, search: true }}
        />
        <Alert
          isOpen={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          title={null}
          description="Are you sure you want to delete"
          buttonCenter={true}
          cancelButton={{
            show: true,
            title: "Cancel",
            onClick: () => setShowDeleteModal(false),
          }}
          acceptButton={{
            show: true,
            title: "Delete",
            onClick: confirmDelete,
          }}
        />
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default WorkforceNotifications;
